import TechActionType from "../../../_common/TechActionType";
import { useEffect, axios, useNavigate, useState, SearchIcon, handleApiError, decryptData, BluePlus } from "../../AdminImport";
import { createPortal } from "react-dom";
import './TechnologyDropdown.css';

const TechDropdown = (props) => {
  const [techOptions, setTechOptions] = useState([]);
  const [filteredTechOptions, setFilteredTechOptions] = useState([]);
  const [newTechName, setNewTechName] = useState("");
  const [isCreatingTag, setIsCreatingTag] = useState(false);
  const [createTagError, setCreateTagError] = useState("");
  const {
    dispatch,
    technologyNames,
    techDataComingChild,
    selectedTechIds,
    selectedTech,
    enableTagCreation = false,
    addTagButtonText = "Add New Tag",
    addTagModalId = "addTagModal",
    selectedTechIdsfromChild = defaultTechIdHandler,
  } = props;
  const navigate = useNavigate();
  const tagNameRegex = /^(?!.*(\-\-|\/\/|\.\.|\s{2}))(?!.*:{2})[a-zA-Z0-9 .\-/]{1,50}$/;
  function defaultTechIdHandler(techIdData) {
  }
  const getParsedUser = () => {
    let parsedObject;
    const data = localStorage.getItem("userData");
    data ? parsedObject = decryptData(data, process.env.REACT_APP_USER_KEY) : navigate("/error/statusCode=400");
    return parsedObject;
  };

  const fetchTechOptions = async () => {
    const parsedObject = getParsedUser();
    const url = `${process.env.REACT_APP_API_URL_DOTNET}/Project/technology`;
    const headers = {
      Authorization: `Bearer ${parsedObject["token"]}`,
    }
    try {
      const response = await axios.get(url, { headers });
      const sortedOptions = response.data?.result.sort((a, b) => {
        const nameA = a.techName.toUpperCase();
        const nameB = b.techName.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      setTechOptions(sortedOptions);
      setFilteredTechOptions(sortedOptions);
      return sortedOptions;
    } catch (error) {
      const statusCode = error.response ? error.response.status : null;
      handleApiError(statusCode, navigate);
      return [];
    }
  };

  useEffect(() => {
    fetchTechOptions();
  }, []);

  const handleOptionClick = (e, tech) => {
    if (Array.isArray(technologyNames)) {
      if (e.target.checked) {
        dispatch({
          type: TechActionType.SET_TECH_NAME,
          payload: [...technologyNames, tech.techName]
        })
        dispatch({
          type: TechActionType.SET_TECH_ID,
          payload: [...selectedTechIds, tech.id]
        })
      } else if (!e.target.checked) {
        dispatch({
          type: TechActionType.SET_TECH_NAME,
          payload: technologyNames.filter((item) => item !== tech.techName)
        })
        dispatch({
          type: TechActionType.SET_TECH_ID,
          payload: selectedTechIds.filter((item) => item !== tech.id)
        })
      }
    }
  };

  const handleSearchChange = (e) => {
    const filtered = techOptions.filter((tech) =>
      tech.techName.toLowerCase().startsWith(e.target.value.toLowerCase())
    );
    setFilteredTechOptions(filtered);
  };

  useEffect(() => {
    if (selectedTech) {
      const selectedTechNames = selectedTech.map((tech) => tech);
      techDataComingChild(selectedTechNames);
      if (techOptions) {
        const selectedTechIds = techOptions
          .filter((tech) => selectedTech.includes(tech.techName))
          .map((tech) => tech.id);
        selectedTechIdsfromChild(selectedTechIds);
      }
    }
  }, [selectedTech, techOptions]);

  useEffect(() => {
    if (technologyNames) {
      const selectedTechNames = technologyNames.map((tech) => tech);
      techDataComingChild(selectedTechNames);
    }
    if (selectedTechIds) {
      const selectedTechId = selectedTechIds?.map(id => id);
      selectedTechIdsfromChild(selectedTechId);
    }
  }, []);

  const handleCreateTechnology = async () => {
    const trimmedTagName = newTechName.trim();
    if (!tagNameRegex.test(trimmedTagName)) {
      setCreateTagError("Categories can only include letters(a-z), hyphens (-) , periods (.), and slashes with character limit up to 50");
      return;
    }

    const isDuplicateTag = techOptions.some((tech) => tech.techName.toLowerCase() === trimmedTagName.toLowerCase());
    if (isDuplicateTag) {
      setCreateTagError("Tag already exists");
      return;
    }

    setCreateTagError("");
    setIsCreatingTag(true);
    try {
      const parsedObject = getParsedUser();
      const url = `${process.env.REACT_APP_API_URL_DOTNET}/Project/createTechnology`;
      const headers = {
        Authorization: `Bearer ${parsedObject["token"]}`,
        "Content-Type": "application/json",
      };

      await axios.post(url, JSON.stringify(trimmedTagName), { headers });
      const updatedOptions = await fetchTechOptions();
      const createdTag = updatedOptions.find((tech) => tech.techName.toLowerCase() === trimmedTagName.toLowerCase());

      if (createdTag && Array.isArray(technologyNames) && Array.isArray(selectedTechIds)) {
        const updatedNames = technologyNames.includes(createdTag.techName)
          ? technologyNames
          : [...technologyNames, createdTag.techName];
        const updatedIds = selectedTechIds.includes(createdTag.id)
          ? selectedTechIds
          : [...selectedTechIds, createdTag.id];

        dispatch({
          type: TechActionType.SET_TECH_NAME,
          payload: updatedNames,
        });
        dispatch({
          type: TechActionType.SET_TECH_ID,
          payload: updatedIds,
        });
      }

      setNewTechName("");
    } catch (error) {
      const errorMessage = error?.response?.data?.error || error?.response?.data?.message || "Unable to create tag";
      setCreateTagError(errorMessage);
    } finally {
      setIsCreatingTag(false);
    }
  };

  const resetCreateTagState = () => {
    setNewTechName("");
    setCreateTagError("");
  };

  const isTagDuplicate = techOptions.some((tech) => tech.techName.toLowerCase() === newTechName.trim().toLowerCase());
  const isTagNameValid = tagNameRegex.test(newTechName.trim());

  return (
    <>
      <div
        className="d-flex align-items-center ps-1 associate-search-log-wrapper mb-2"
        style={{ width: "95%" }}
      >
        <SearchIcon />
        <input
          className="search-dropdowns"
          type="text"
          placeholder="Search tech..."
          onChange={handleSearchChange}
        />
      </div>
      <div style={{ maxHeight: "6rem", overflow: "auto" }} className="dp-scroll">
        {filteredTechOptions.map((tech) => (
          <div key={tech.id} className="form-check small checkbox tech-wrap">
            <label
              className="form-check-label tech-label"
              htmlFor={tech.id+tech.techName}
              style={{ display: "block", cursor: "pointer" }}
              onClick={(e) => {
                handleOptionClick(e, tech)
              }}
            >
              <span>{tech.techName}</span>
              <input
                readOnly
                className="form-check-input tech-checkbox"
                type="checkbox"
                id={tech.id}
                value={tech.techName}
                checked={selectedTechIds?.includes(tech.id)||technologyNames?.includes(tech.techName)}
              />
            </label>
          </div>
        ))}
      </div>
      {enableTagCreation && (
        <div className="tech-dropdown-add-section">
          <button
            type="button"
            className="btn tech-dropdown-add-btn ps-1"
            data-bs-toggle="modal"
            data-bs-target={`#${addTagModalId}`}
            onClick={resetCreateTagState}
          >
            <BluePlus />
            <span className="add-csv-text mx-1">{addTagButtonText}</span>
          </button>
        </div>
      )}

      {enableTagCreation && createPortal(
        <div className="modal fade" id={addTagModalId} tabIndex="-1" aria-labelledby={`${addTagModalId}Label`} aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header border-bottom">
                <h1 className="modal-title add-category-head" id={`${addTagModalId}Label`}>Add New Tag</h1>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={resetCreateTagState}></button>
              </div>
              <div className="modal-body">
                <div className="mb-2">
                  <label htmlFor={`${addTagModalId}Name`} className="col-form-label form-title-names">
                    Tag Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id={`${addTagModalId}Name`}
                    placeholder="Enter Tag Name"
                    value={newTechName}
                    maxLength={50}
                    onChange={(e) => {
                      const inputName = e.target.value;
                      setNewTechName(inputName);
                      if (inputName.trim() !== "" && !tagNameRegex.test(inputName.trim())) {
                        setCreateTagError("Categories can only include letters(a-z), hyphens (-) , periods (.), and slashes with character limit up to 50");
                      } else {
                        setCreateTagError("");
                      }
                    }}
                  />
                </div>
                {newTechName.trim() && createTagError && <span className="text-danger error-msg tech-dropdown-error-text">{createTagError}</span>}
                {!createTagError && newTechName.trim() && isTagDuplicate && (
                  <span className="text-danger error-msg tech-dropdown-error-text">Tag already exists</span>
                )}
              </div>
              <div className="modal-footer border-top gap-2">
                <button type="button" className="add-category-no-btn me-1" data-bs-dismiss="modal" onClick={resetCreateTagState}>
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary add-category-yes-btn ms-1"
                  onClick={handleCreateTechnology}
                  disabled={isCreatingTag || !isTagNameValid || createTagError !== "" || isTagDuplicate}
                  data-bs-dismiss={isCreatingTag || !isTagNameValid || createTagError !== "" || isTagDuplicate ? "" : "modal"}
                >
                  {isCreatingTag ? "Saving..." : "Save"}
                </button>
              </div>
            </div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
};

export default TechDropdown;